
//input 日付
$(function () {
    flatpickr(".js-datePicker", {
        locale: "ja",
        dateFormat: "Y/m/d",
        disableMobile: true,
    });
});
